import { render, staticRenderFns } from "./NotificationsCounterProvider.vue?vue&type=template&id=0ba464ce"
import script from "./NotificationsCounterProvider.vue?vue&type=script&lang=ts"
export * from "./NotificationsCounterProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports